import PasswordExpiration from "./PasswordExpiration";

export default PasswordExpiration;
